import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
// Constants imports
import { URLConstants } from '../../../../_constants/url-constants';
import { CacheDuration } from '../../../../_constants/cache-duration';
// Service imports
import { MPCacheRegistrationService } from '../../../../_services/shared-services/mp-cache-registration-service';
import { APPaymentResultDto } from '../../_models/accounts-payable/ap-payment/ap-payment-result-dto';
import { StatusMessageResultDto } from '../../../../_models/status-message-result-dto';
import { TransactionLogResultDto } from '../../_models/common/transaction-log-result-dto';
import { APServiceChargeEditorResultDto } from '../../_models/accounts-payable/service-charge/ap-service-charge-editor-result-dto';
import { GLSubcategorySelectorResultDto } from '../../_models/common/gl-account/glsubcategory-selector-result-dto';
import { APPaymentVoidEditorResultDto } from '../../_models/accounts-payable/ap-payment/ap-payment-void-editor-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../../_services/shared-services/mp-cache-registration-service";
export class APPaymentService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
    }
    getAPPaymentDetail(param) {
        const url = `${URLConstants.ccCBAPPaymentApiUrl}/detail${param.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, param.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(APPaymentResultDto, response)));
    }
    getAPPaymentDownloadDocument(param) {
        const url = `${URLConstants.ccCBAPPaymentApiUrl}/download/document${param.getQueryString()}`;
        return this.httpClient
            .get(url, { responseType: 'arraybuffer' })
            .pipe(map((responseData) => new Blob([responseData])));
    }
    voidPayment(baseParam) {
        return this.httpClient
            .put(`${URLConstants.ccCBAPPaymentApiUrl}/void`, classToPlain(baseParam))
            .pipe(map((responseData) => plainToClass(StatusMessageResultDto, responseData)));
    }
    updatePaymentPostDate(baseParam) {
        return this.httpClient
            .put(`${URLConstants.ccCBAPPaymentApiUrl}/postdate`, classToPlain(baseParam))
            .pipe(map((responseData) => responseData));
    }
    getAPPayemntTransactionLog(baseParam) {
        const url = `${URLConstants.ccCBAPPaymentApiUrl}/history${baseParam.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParam.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(TransactionLogResultDto, response)));
    }
    getServiceChargeEditor(param) {
        const url = `${URLConstants.ccCBAPPaymentApiUrl}/servicecharge/editor${param.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(APServiceChargeEditorResultDto, response)));
    }
    addServiceCharge(param) {
        const url = `${URLConstants.ccCBAPPaymentApiUrl}/servicecharge`;
        return this.httpClient.post(url, classToPlain(param));
    }
    getServiceChargeEditorSubcategories(params) {
        const url = `${URLConstants.ccCBAPPaymentApiUrl}/subcategories${params.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(GLSubcategorySelectorResultDto, response)));
    }
    getMinVoidDate(apPaymentId) {
        const url = `${URLConstants.ccCBAPPaymentApiUrl}/void/editor?apPaymentId=${apPaymentId}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(APPaymentVoidEditorResultDto, response)));
    }
}
APPaymentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function APPaymentService_Factory() { return new APPaymentService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: APPaymentService, providedIn: "root" });
